<h1 mat-dialog-title [innerHTML]="data.title"></h1>
<div mat-dialog-content [innerHTML]="data.text"></div>
<div mat-dialog-actions align="end">
  <button
    mat-button
    (click)="close(false)"
    data-action="confirmation-dialog-cancel-button"
  >
    {{ data.closeText }}
  </button>
  <button
    mat-raised-button
    [color]="data.severity"
    (click)="close(true)"
    data-action="confirmation-dialog-confirm-button"
  >
    {{ data.confirmText }}
  </button>
</div>
